<header>
  <div class="header-items">
    <nav
      class="burguer-menu"
      [ngClass]="sidebarService.isOpen() ? 'open-nav' : 'close-nav'"
      (click)="sideBarTooggle()"
      tabindex="0"
      (keydown)="sideBarTooggle()"
    >
      <i
        class="burguer-menu"
        [ngClass]="sidebarService.isOpen() ? 'bi bi-x-lg' : 'bi bi-list'"
      ></i>
    </nav>
    <div class="img-container">
      <img
        [routerLink]="['/']"
        routerLinkActive="router-link-active"
        class="icon-title cursor-pointer"
        [ngSrc]="'/logos/Logifruit logotipo verde.png'"
        [fill]="true"
        priority
        alt=""
      />
    </div>
    <div class="right-side">
      <span class="icon bell">
        <div class="bell-container">
          <svg
            (click)="toogleMenuNoti()"
            (keydown)="toogleMenuNoti()"
            id="Capa_5"
            data-name="Capa 5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 300 300"
          >
            <defs>
              <style>
                .cls-1 {
                  fill: currentColor;
                }

                .cls-2 {
                  fill: currentColor;
                }
              </style>
            </defs>
            <path
              class=""
              d="M124.34,215.39c.47,9.01,7.31,16.53,15.34,19.81,4.04,1.65,8.44,2.34,12.78,2.51,4.69.18,9.52-.23,14.04-1.53,6.42-1.85,12.07-5.61,15.86-11.15,1.75-2.56,3.32-5.73,3.77-8.85.23-1.6-.39-3.22-2.1-3.69-1.41-.39-3.46.48-3.69,2.1-.09.63-.26,1.25-.44,1.85-.2.67-.46,1.32-.7,1.98-.11.29.34-.74,0-.03-.09.19-.18.39-.27.58-.21.44-.44.87-.68,1.3-.53.94-1.13,1.82-1.76,2.68.53-.72-.05.05-.18.21-.19.23-.38.45-.58.67-.46.51-.94,1-1.44,1.46-.45.42-.92.82-1.41,1.2-.36.29.59-.41-.02.01-.13.09-.25.18-.37.27-.32.23-.65.45-.98.66-.63.4-1.27.77-1.93,1.12-.35.18-.69.35-1.05.52-.2.09-.4.18-.61.28.48-.22-.14.06-.29.12-3.79,1.49-7.39,2.09-11.27,2.24-4.39.17-8.2-.1-12.32-1.32-.81-.24-1.6-.53-2.39-.82-.55-.2-.14-.05-.02,0-.2-.09-.4-.18-.6-.27-.38-.18-.76-.37-1.14-.56-.64-.34-1.26-.7-1.86-1.1-.29-.19-.57-.39-.85-.58-.12-.09-.24-.18-.36-.27.6.44.05.04-.08-.08-.98-.84-1.91-1.73-2.73-2.73-.22-.27-.49-.66-.11-.13-.18-.25-.36-.49-.53-.74-.29-.43-.57-.87-.83-1.32-.3-.51-.57-1.04-.82-1.58-.12-.25-.4-1.07-.06-.11-.08-.22-.18-.44-.26-.66-.3-.8-.56-1.62-.76-2.46-.07-.31-.14-.61-.2-.92-.08-.44-.01-1.31-.03-.04,0-.2-.05-.41-.06-.62-.08-1.62-1.32-3-3-3-1.56,0-3.08,1.37-3,3h0Z"
            />
            <path
              class="cls-1"
              d="M154.41,80.14c-5.76.04-11.87,2.05-14.41,7.68-.59,1.3-1.03,2.62-1.25,4.03-.12.76-.22,1.53-.27,2.3-.02.33-.03.65-.05.98-.03.4-.18.7,0,.14-.06.19-.09.42-.14.62-.03.14-.27.64-.04.19.26-.5-.03.07-.1.13-.48.42.5-.39,0,0-.1.07-.3.23-.36.33.02-.03.47-.3-.03.01-.42.26-.84.52-1.27.76-8,4.41-15.91,9.13-22.3,15.78-8.47,8.82-13.04,20.33-13.18,32.55-.07,5.93,0,11.87,0,17.8s.1,11.9,0,17.85c-.04,2.54-1.79,5.06-2.89,7.26l-5.68,11.35c-1.28,2.56-2.6,5.11-3.84,7.69-.38.8-.7,1.59-.7,2.49-.02,2.19,1.53,4.21,3.68,4.71.63.15,1.26.14,1.89.14h60.95c3.86,0,3.87-6,0-6h-60.47c-.26,0-.98-.14-1.22,0-.14.08.53.15.57.17.54.32.79,1.33.38,1.7.15-.13.25-.49.33-.67l1.75-3.5c3.2-6.4,6.4-12.79,9.59-19.19,1.23-2.47,1.64-4.96,1.64-7.66v-32.02c0-3.42.14-6.8.77-10.04,1.09-5.61,2.99-10.21,6.18-14.91.35-.52.71-1.03,1.09-1.53.08-.11.51-.66.22-.3.2-.26.41-.51.62-.77.75-.92,1.54-1.81,2.36-2.68,1.56-1.65,3.24-3.18,4.99-4.63.37-.31.75-.61,1.13-.91.2-.16.55-.42.14-.11.25-.19.49-.37.74-.56.76-.57,1.54-1.13,2.32-1.67,1.36-.95,2.75-1.86,4.14-2.77,2.44-1.6,5.04-2.9,7.61-4.29,1.71-.93,3.42-2.05,4.29-3.86.56-1.15.76-2.35.84-3.63.04-.58.06-1.16.12-1.74.04-.36,0,0,0,.06.02-.14.05-.29.07-.43.07-.37.15-.74.25-1.11.07-.27.15-.53.24-.79.04-.12.3-.77.19-.51s.19-.36.24-.46c.16-.3.34-.59.53-.87.07-.11.14-.21.22-.31-.03.04-.3.36-.08.11.17-.19.33-.38.51-.56.21-.21.43-.41.66-.6-.42.35.18-.11.34-.21.22-.14.46-.28.69-.4.11-.06.72-.35.51-.26-.19.08.55-.2.71-.25.29-.09.57-.17.86-.25,1.45-.36,2.3-.41,3.92-.42,3.86-.03,3.87-6.03,0-6h0Z"
            />
            <path
              class="cls-1"
              d="M154.41,86.14c2.6.02,4.85.36,6.81,1.64.11.07.21.15.32.22.38.25-.33-.3,0,0,.19.17.38.33.56.51s.34.37.51.56c.23.25-.05-.08-.08-.11.1.14.2.27.29.41.16.25.32.51.46.77.06.1.36.73.24.46s.15.39.19.51c.1.3.19.61.27.92s.15.65.21.97c.03.14.05.29.07.43,0-.06-.05-.42,0-.06.07.65.08,1.31.14,1.96.1,1.23.31,2.37.86,3.48.9,1.81,2.64,2.92,4.37,3.84,4.04,2.18,7.96,4.44,11.72,7.06.82.57,1.62,1.15,2.42,1.75.19.14.37.28.55.42-.42-.32-.06-.05.14.11.44.35.88.7,1.31,1.06,1.72,1.43,3.36,2.94,4.9,4.57.82.87,1.61,1.76,2.36,2.69.18.22.35.44.53.66-.28-.36.14.19.22.3.4.54.79,1.09,1.17,1.65.72,1.07,1.4,2.18,2.02,3.32.32.59.63,1.18.92,1.78.14.28.27.57.4.85.06.12.4.89.27.59,2.25,5.27,3.22,10.8,3.26,16.43.04,6.1,0,12.2,0,18.3,0,5.7-.1,11.4,0,17.1.06,3.5,1.76,6.39,3.27,9.42,1.8,3.61,3.61,7.22,5.41,10.83l4.32,8.64c.08.17.18.51.32.64-.43-.4-.15-1.4.38-1.71.05-.03.73-.08.56-.17-.24-.14-.98,0-1.25,0-5.87,0-11.75,0-17.62,0-8.46,0-16.92,0-25.38,0-5.53,0-11.06,0-16.59,0-.28,0-.56,0-.84,0-3.86,0-3.87,6,0,6,4.15,0,8.29,0,12.44,0,8.45,0,16.9,0,25.36,0,6.94,0,13.87,0,20.81,0,1.44,0,3.14.2,4.54-.22,3.19-.96,3.96-4.43,2.66-7.15-.45-.94-.94-1.87-1.41-2.81-3.34-6.67-6.67-13.35-10.01-20.02-.55-1.1-.96-2.18-.98-3.45,0-.54,0-1.08,0-1.62,0-3.29,0-6.57,0-9.86v-22.56c0-10.05-2.4-19.91-8.26-28.19-5.16-7.29-12.13-12.62-19.54-17.44-2.53-1.65-5.25-2.95-7.88-4.42-.36-.2-.72-.42-1.07-.65-.1-.06-.2-.15-.3-.21.05.03.39.41.27.2-.06-.11-.31-.32-.41-.39-.41-.28.52.43.05.05-.07-.05-.36-.64-.1-.13.27.54-.24-1.12-.16-.61.08.48-.01-.22-.02-.34-.02-.33-.03-.65-.05-.98-.06-.86-.17-1.73-.32-2.59-.24-1.35-.68-2.63-1.26-3.87-1.11-2.39-3.1-4.43-5.44-5.63-2.76-1.42-5.84-1.91-8.92-1.93-3.86-.03-3.87,5.97,0,6h0Z"
            />
          </svg>

          @if (totalNotifications() > 0) {
            <span class="notification-badget">{{ totalNotifications() }}</span>
          }
        </div>

        <span class="relative z-50">
          <div
            id="mega-menu-dropdown"
            class="absolute w-72 text-sm bg-white border border-gray-200 rounded-xl shadow-lg top-10 right-0 transition-all duration-300 ease-in-out transform opacity-0"
            [ngClass]="isMenuNotiOpen() ? 'open' : 'close'"
          >
            <div
              class="p-4 border-b border-gray-100 font-semibold text-gray-800"
            >
              {{ 'COMPARTIDOS.HEADER.NOTIFICACIONES' | translate }}
            </div>

            <div class="p-3 text-gray-900 max-h-80 overflow-y-auto">
              <ul class="notificaciones-list">
                @for (notification of notifications(); track $index) {
                  <li
                    class="bg-gray-50 hover:bg-gray-100 transition rounded-lg p-3 cursor-pointer"
                  >
                    <a class="flex items-start gap-3 text-sm text-gray-700">
                      <span class="flex-1">{{
                        `${notification.titleKey}_home`
                          | translate: notification.titleParams
                      }}</span>
                    </a>
                  </li>
                }
                @if (totalNotifications() === 0) {
                  <li>
                    <p>
                      {{ 'COMPARTIDOS.HEADER.NO_NOTIFICACIONES' | translate }}
                    </p>
                  </li>
                }
              </ul>
            </div>
          </div>
        </span>
      </span>

      <div
        (click)="toogleMenu()"
        class="icon user"
        tabindex="0"
        (keydown)="toogleMenu()"
      >
        <!-- Icono -->
        <svg
          id="fond._blanco"
          data-name="fond. blanco"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 300 300"
        >
          <defs>
            <style>
              .cls-1 {
                fill: currentColor;
              }
            </style>
          </defs>
          <path
            class="cls-1"
            d="M152.61,166.69c-50.18,0-50.95-45.49-50.95-45.95v-34.57c0-5.64,1.8-10.21,5.36-13.6,6.06-5.76,15.08-5.68,16.35-5.65h56.86c17.22,0,22.67,12.39,23.14,18.93,0,.1.01.2.01.31v31.27c0,.49-.58,49.26-50.77,49.26ZM122.83,75.41c-1.23,0-6.69.18-9.98,3.34-1.81,1.74-2.7,4.17-2.7,7.42v34.55c.01,1.5.84,37.48,42.45,37.48s42.28-39.1,42.28-40.77v-31.07c-.17-1.53-1.74-10.95-14.66-10.95h-56.94c-.07,0-.14,0-.21,0,0,0-.09,0-.25,0Z"
          />
          <path
            d="M233.36,246.01c-2.35,0-4.25-1.9-4.25-4.25v-19.46c0-6.53-1.54-12.79-4.44-18.11-4.45-8.15-10.79-12.36-18.85-12.51-19.09-.35-40.04-.3-48.98-.28-2.07,0-3.56,0-4.34,0-.75,0-2.24,0-4.31,0-8.95-.02-29.89-.07-48.98.28-8.06.15-14.41,4.36-18.85,12.51-2.9,5.33-4.44,11.59-4.44,18.11v19.46c0,2.34-1.9,4.25-4.25,4.25s-4.25-1.9-4.25-4.25v-19.46c0-7.94,1.89-15.61,5.48-22.18,5.93-10.87,14.97-16.73,26.15-16.94,19.18-.36,40.19-.3,49.16-.29,2.04,0,3.52,0,4.29,0,.8,0,2.27,0,4.32,0,8.97-.02,29.98-.07,49.16.29,11.18.21,20.22,6.06,26.15,16.94,3.58,6.57,5.48,14.24,5.48,22.18v19.46c0,2.34-1.9,4.25-4.25,4.25Z"
          />
        </svg>
        <!-- Menu desplegable -->
        <span class="relative z-50">
          <div
            id="mega-menu-dropdown"
            class="absolute w-2xs text-sm bg-white border rounded-lg shadow-md md:grid-cols-3 top-0 right-0 transition-opacity duration-300 ease-in-out transform opacity-0"
            [ngClass]="isMenuOpen() ? 'open' : 'close'"
          >
            <div class="p-4 pb-0 text-gray-900 md:pb-4">
              <ul class="space-y-4 flex flex-col gap-4">
                <li>
                  <a
                    routerLinkActive="active"
                    routerLink="/Account/MyProfile"
                    class="text-gray-500 flex gap-2 row-dialog"
                  >
                    <app-icon [name]="'usuario'" [strokeWidth]="7" size="1.5em">
                    </app-icon>
                    {{ 'COMPARTIDOS.HEADER.PERFIL' | translate }}
                  </a>
                </li>
                <li>
                  <a
                    routerLinkActive="active"
                    routerLink="/Operador/DatosOperador"
                    class="text-gray-500 flex gap-2 row-dialog"
                  >
                    <app-icon [name]="'cliente'" [strokeWidth]="5" size="1.5em">
                    </app-icon>
                    {{ 'COMPARTIDOS.HEADER.DATOS_EMPRESA' | translate }}
                  </a>
                </li>
                <li>
                  <a
                    routerLinkActive="active"
                    (click)="logOut()"
                    tabindex="0"
                    (keydown)="logOut()"
                    class="text-gray-500 flex gap-2 row-dialog"
                  >
                    <app-icon
                      [name]="'cerrar_sesion'"
                      a
                      [strokeWidth]="15"
                      size="1.5em"
                    >
                    </app-icon>
                    {{ 'COMPARTIDOS.HEADER.LOGOUT' | translate }}
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </span>
      </div>
    </div>
  </div>
</header>

<!-- ARREGLAR ESTO -->
